import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { defineMessages } from 'react-intl';
import _ from 'lodash';
import { loadFavoriteCourses } from '../../../actions/auth';
import Layout from '../../../components/Layout/Layout';
import CourseDetailsContent from './CourseDetailsContent';
import notFound from '../../not-found/index';
import { getCourseBySlug, getCourseTextNotes, getCourseVideoNotes } from '../../../actions/courseDetails';
import { getDiscussions } from '../../../actions/discussions';
import { ssrRequest } from '../../../helpers';
import isLoggedIn from '../../../helpers/checkAuth';
var messages = defineMessages({
  coursesTitle: {
    id: "CourseDetailsContent.coursesTitle",
    defaultMessage: [{
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": " - Course"
    }]
  }
});
function action(_x) {
  return _action.apply(this, arguments);
}
function _action() {
  _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(context) {
    var _this = this,
      _context$query;
    var store, params, fetch, formatMessage, cloudfrontUrl, organizationSlug, courseSlug, _store$getState, auth, promises, getCourseRequest, _store$getState2, courseDetails, _courseDetails$course, isAvailable, courseType, requests, notFoundReq, title, description, keywords, imageUrl;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          store = context.store, params = context.params, fetch = context.fetch, formatMessage = context.intl.formatMessage, cloudfrontUrl = context.cloudfrontUrl, organizationSlug = context.organizationSlug;
          courseSlug = params.courseSlug;
          _store$getState = store.getState(), auth = _store$getState.auth;
          promises = [];
          _context5.next = 6;
          return ssrRequest({
            getAction: getCourseBySlug.bind(this, courseSlug),
            fetch: fetch,
            store: store
          });
        case 6:
          getCourseRequest = _context5.sent;
          if (![403, 404].includes(_.get(getCourseRequest, 'status'))) {
            _context5.next = 9;
            break;
          }
          return _context5.abrupt("return", notFound(context));
        case 9:
          _store$getState2 = store.getState(), courseDetails = _store$getState2.courseDetails;
          _courseDetails$course = courseDetails.course, isAvailable = _courseDetails$course.isAvailable, courseType = _courseDetails$course.type;
          if (isLoggedIn(auth)) {
            if (isAvailable) {
              if (!_.includes(['podcast', 'livestream'], courseType)) {
                promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var res, resText, json, result;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return store.dispatch({
                          type: getCourseTextNotes(courseSlug).types[0]
                        });
                      case 2:
                        _context.prev = 2;
                        _context.next = 5;
                        return getCourseTextNotes(courseSlug).promise(fetch);
                      case 5:
                        res = _context.sent;
                        _context.next = 8;
                        return res.text();
                      case 8:
                        resText = _context.sent;
                        json = resText ? JSON.parse(resText) : {};
                        if (!(res.status !== 200)) {
                          _context.next = 14;
                          break;
                        }
                        if (![403, 404].includes(res.status)) {
                          _context.next = 13;
                          break;
                        }
                        return _context.abrupt("return", notFound(context));
                      case 13:
                        return _context.abrupt("return", store.dispatch({
                          error: json,
                          type: getCourseTextNotes(courseSlug).types[2]
                        }));
                      case 14:
                        result = {
                          status: res.status,
                          json: json
                        };
                        return _context.abrupt("return", store.dispatch({
                          result: result,
                          type: getCourseTextNotes(courseSlug).types[1]
                        }));
                      case 18:
                        _context.prev = 18;
                        _context.t0 = _context["catch"](2);
                        _context.t0.message = "MIDDLEWARE ERROR: ".concat(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message);
                        console.error(_context.t0);
                        return _context.abrupt("return", store.dispatch({
                          error: _context.t0,
                          type: getCourseTextNotes(courseSlug).types[2]
                        }));
                      case 23:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[2, 18]]);
                })));
                promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var res, resText, json, result;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return store.dispatch({
                          type: getCourseVideoNotes(courseSlug).types[0]
                        });
                      case 2:
                        _context2.prev = 2;
                        _context2.next = 5;
                        return getCourseVideoNotes(courseSlug).promise(fetch);
                      case 5:
                        res = _context2.sent;
                        _context2.next = 8;
                        return res.text();
                      case 8:
                        resText = _context2.sent;
                        json = resText ? JSON.parse(resText) : {};
                        if (!(res.status !== 200)) {
                          _context2.next = 14;
                          break;
                        }
                        if (![403, 404].includes(res.status)) {
                          _context2.next = 13;
                          break;
                        }
                        return _context2.abrupt("return", notFound(context));
                      case 13:
                        return _context2.abrupt("return", store.dispatch({
                          error: json,
                          type: getCourseVideoNotes(courseSlug).types[2]
                        }));
                      case 14:
                        result = {
                          status: res.status,
                          json: json
                        };
                        return _context2.abrupt("return", store.dispatch({
                          result: result,
                          type: getCourseVideoNotes(courseSlug).types[1]
                        }));
                      case 18:
                        _context2.prev = 18;
                        _context2.t0 = _context2["catch"](2);
                        _context2.t0.message = "MIDDLEWARE ERROR: ".concat(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message);
                        console.error(_context2.t0);
                        return _context2.abrupt("return", store.dispatch({
                          error: _context2.t0,
                          type: getCourseVideoNotes(courseSlug).types[2]
                        }));
                      case 23:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[2, 18]]);
                })));
              }
              promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var query;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      query = {
                        page: 1,
                        sort: '-createDate',
                        search: '',
                        perPage: 50,
                        courseId: courseSlug
                      };
                      return _context3.abrupt("return", ssrRequest({
                        getAction: getDiscussions.bind(_this, query),
                        fetch: fetch,
                        store: store
                      }));
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              })));
            }
            promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    return _context4.abrupt("return", store.dispatch(loadFavoriteCourses(fetch)));
                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            })));
          }
          _context5.next = 14;
          return Promise.all(promises.map(function (promise) {
            return promise();
          }));
        case 14:
          requests = _context5.sent;
          notFoundReq = _.find(requests, function (item) {
            return [403, 404].includes(_.get(item, 'status'));
          });
          if (!notFoundReq) {
            _context5.next = 18;
            break;
          }
          return _context5.abrupt("return", notFound(context));
        case 18:
          title = formatMessage(messages.coursesTitle, {
            name: _.get(courseDetails, 'course.name', '')
          });
          description = _.get(courseDetails, 'course.description', '');
          keywords = _.get(courseDetails, 'course.tags', '');
          imageUrl = _.get(courseDetails, 'course.thumbnail.path');
          if (imageUrl) {
            imageUrl = "".concat(cloudfrontUrl, "/").concat(imageUrl);
          }
          return _context5.abrupt("return", {
            chunks: ['course-details'],
            title: title,
            description: description,
            keywords: keywords,
            imageUrl: imageUrl,
            component: /*#__PURE__*/_jsx(Layout, {
              context: context,
              tour: organizationSlug || _.includes(['podcast', 'livestream'], courseType) ? undefined : 'courseDetails',
              className: "full-height"
            }, void 0, /*#__PURE__*/_jsx(CourseDetailsContent, {
              data: {},
              title: title,
              searchSessionId: (_context$query = context.query) === null || _context$query === void 0 ? void 0 : _context$query.searchSessionId
            }))
          });
        case 24:
        case "end":
          return _context5.stop();
      }
    }, _callee5, this);
  }));
  return _action.apply(this, arguments);
}
export default action;